import { render, staticRenderFns } from "./cartDetail2.vue?vue&type=template&id=43493a3e&scoped=true&"
import script from "./cartDetail2.vue?vue&type=script&lang=js&"
export * from "./cartDetail2.vue?vue&type=script&lang=js&"
import style0 from "./cartDetail2.vue?vue&type=style&index=0&id=43493a3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43493a3e",
  null
  
)

export default component.exports